import { React, useEffect, useState } from "react";
import { Box, Typography } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";

import MyQuotientChart from "../components/MyQuotientChart";
import MobileLoading from "../../../components/MobileLoading";
import { AppButton } from "../components/InputComponents";

import useStyles from './MyGoal.style';
import Cookies from 'universal-cookie';


const cookies = new Cookies();

const MyGoalResultText = props => {
	const { color, title, subtitle } = props
	return (
		<>
			<Typography variant="h5" style={{ color: color }}>{title}</Typography>
			<Typography>{subtitle}</Typography>
		</>
	)
}

const MyGoal = props => {
	const classes = useStyles();

	const [loading, setLoading] = useState(true);

	const [healthProfile, setHealthProfile] = useState('');

	useEffect(() => {
		const getHealthProfile = async () => {
			try {
				let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PATIENT_PROFILE}`, {
					headers: {
						'X-ACCESS-TOKEN': cookies.get('token')
					}
				});
				if (!response) return;
				let json = await response.json();
				setHealthProfile(json);
			} catch (error) {
				console.log(error);
			} finally {
				setLoading(false);
			};
		};

		getHealthProfile();
	}, []);

	if (loading) return <MobileLoading />

	return (
		<Box className={classes.root}>
			<div>
				<Typography variant="h3" className={classes.title}>My Goals</Typography>
				<div className={classes.infoText}>
					{healthProfile.currentChildrenQty === healthProfile.desiredChildrenQty &&
						<MyGoalResultText color="gold" title="You’re on the Goal Line" subtitle="Congratulations, You have reached your goal!" />
					}
					{healthProfile.currentChildrenQty < healthProfile.desiredChildrenQty &&
						<MyGoalResultText color="MediumAquaMarine" title="You’re in the Green Zone" subtitle="You have not reached your goal yet" />
					}
					{healthProfile.currentChildrenQty > healthProfile.desiredChildrenQty &&
						<MyGoalResultText color="purple" title="You’re in the Purple Zone" subtitle="You have passed your goal" />
					}
				</div>
				<Box className={classes.chart}>
					<MyQuotientChart
						currentChildren={healthProfile.currentChildrenQty}
						desiredChildren={healthProfile.desiredChildrenQty}
					/>
				</Box>
			</div>
			<Box className={classes.footer}>
				<AppButton
					variant="contained"
					color="secondary"
					fullWidth
					size="large"
					component={RouterLink}
					to="/app/dashboard"
					onClick={props.scrollToTop}
				>
					Back
				</AppButton>
			</Box>
		</Box>
	);
};

export default MyGoal;
